export default __webpack_public_path__ + "static/media/subir.59f1d200.svg";